import React, { forwardRef } from 'react';
import { StyledIconButtonProps } from '../';
import { IconButtonProps as MuiIconButtonProps } from '@mui/material';
import { StyledIconButton, Spinner, Text } from './styled';

export const IconButton = forwardRef<HTMLButtonElement, MuiIconButtonProps & StyledIconButtonProps>(
  (props, ref) => (
    <StyledIconButton {...props} ref={ref}>
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        className={'text'}
      >
        {props.children}
      </div>
      {props?.loading && (
        <Spinner
          size={props.size === 'small' ? 16 : props.size === 'medium' ? 20 : 24}
          color={
            props.color
              ? props.variant === 'contained'
                ? 'inherit'
                : props.color === 'inherit'
                  ? 'secondary'
                  : props.color
              : `inherit`
          }
        />
      )}
    </StyledIconButton>
  )
);
